<template>

    <div class="absolute top-0 right-0 z-9" v-if="position === 'top_right'">
        <div
            class="bg-red-500 border-t-2 border-b-2 border-red-400 text-xs font-bold text-white shadow-md
            float-right text-center rotate-45 overflow-hidden absolute right-[-35px] top-[15px] w-[125px]"
        >
            <slot></slot>
        </div>
    </div>

    <div class="absolute top-0 left-0 z-9" v-if="position === 'top_left'">
        <div
             class="bg-green-500 border-t-2 border-b-2 border-green-400 text-xs font-bold text-white shadow-md
            float-right text-center -rotate-45 overflow-hidden absolute left-[-35px] top-[15px] w-[125px]"
        >
            <slot></slot>
        </div>
    </div>

</template>

<script>
export default {
    name: "Ribbon",
    props: {
        position: {
            type: String,
            required: false,
            default: "top_right"
        }
    }
}
</script>

<style scoped>
    .z-9 {
        z-index: 9
    }
    .bg-green-500 {
        background-color: #9AD016;
    }
    .border-green-400 {
        border-color: #90D010;
    }
</style>
